import { FC, ReactNode } from 'react'

import { ErrorBoundary } from '@sentry/react'

import { useSentry } from 'src/Hooks/useSentry'
interface SentryProviderProps {
  children: ReactNode
}

/**
 * Провайдер для инициализации Sentry и установки контекста пользователя
 * Оборачивает приложение в ErrorBoundary для отлова необработанных ошибок
 */
export const SentryProvider: FC<SentryProviderProps> = ({ children }) => {
  useSentry()

  const ErrorFallback: FC<{ error?: Error; resetError?: () => void }> = ({
    error,
    resetError,
  }) => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h1>Упс! Что-то пошло не так</h1>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Мы уже получили уведомление об этой ошибке и работаем над её
        исправлением.
      </p>
      <button
        onClick={resetError}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Попробовать снова
      </button>
      {import.meta.env.DEV && (
        <details style={{ marginTop: '20px', textAlign: 'left' }}>
          <summary style={{ cursor: 'pointer', color: '#007bff' }}>
            Детали ошибки (только в dev mode)
          </summary>
          <pre
            style={{
              marginTop: '10px',
              padding: '10px',
              backgroundColor: '#f5f5f5',
              borderRadius: '5px',
              overflow: 'auto',
            }}
          >
            {error?.message}
            {'\n\n'}
            {error?.stack}
          </pre>
        </details>
      )}
    </div>
  )

  return (
    <ErrorBoundary fallback={<ErrorFallback />} showDialog>
      {children}
    </ErrorBoundary>
  )
}
